import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

export const EntryMeta = styled.div`
  padding: 0 30px 15px;

  ${maxMediaQueries.phablet`
    padding: 0 15px 15px;
  `};
`;
